/**
 * Discover JSON Generator for Artifact
 * 
 * This utility helps create and format a valid discover.json file
 * with the correct structure for the Artifact platform.
 */

// Sample categories and tags to generate diverse content
const categories = [
    'architecture', 'interiors', 'furniture', 'art', 'objects', 
    'lighting', 'materials', 'typography', 'ceramics', 'textiles'
  ];
  
  const styles = [
    'modernist', 'brutalist', 'mid-century', 'minimalist', 'industrial',
    'scandinavian', 'japanese', 'art deco', 'contemporary', 'organic'
  ];
  
  const materials = [
    'wood', 'concrete', 'steel', 'glass', 'ceramic', 'stone', 
    'textile', 'paper', 'plastic', 'marble', 'brass', 'copper'
  ];
  
  const colors = [
    'neutral', 'monochrome', 'earth', 'pastel', 'vibrant', 
    'black', 'white', 'blue', 'green', 'red', 'yellow'
  ];
  
  // Generate a random item for the discover feed
  function generateDiscoverItem(index) {
    // Generate 1-3 random tags from each category
    const getTags = (category, count = Math.floor(Math.random() * 2) + 1) => {
      const shuffled = [...category].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, count);
    };
    
    const allTags = [
      ...getTags(categories),
      ...getTags(styles),
      ...getTags(materials),
      ...getTags(colors)
    ];
    
    // Generate a title with some structure
    const titleParts = [
      ['The', 'A', 'Modern', 'Classic', 'Iconic', 'Sculptural', 'Minimalist'],
      [...categories, ...styles].sort(() => 0.5 - Math.random()).slice(0, 1),
      ['House', 'Design', 'Studio', 'Project', 'Collection', 'Series', 'Installation', 'Piece']
    ];
    
    const title = `${titleParts[0][Math.floor(Math.random() * titleParts[0].length)]} ${
      titleParts[1][0].charAt(0).toUpperCase() + titleParts[1][0].slice(1)
    } ${titleParts[2][Math.floor(Math.random() * titleParts[2].length)]}`;
    
    // Generate a placeholder description
    const descriptionParts = [
      ['Exploring', 'Featuring', 'Showcasing', 'Celebrating', 'Inspired by'],
      [...styles].sort(() => 0.5 - Math.random()).slice(0, 1),
      ['elements', 'aesthetics', 'principles', 'concepts', 'influences'],
      ['with', 'through', 'using', 'via'],
      [...materials].sort(() => 0.5 - Math.random()).slice(0, 1),
      ['and', 'combined with', 'juxtaposed with', 'alongside'],
      [...colors].sort(() => 0.5 - Math.random()).slice(0, 1),
      ['tones', 'hues', 'palette', 'accents']
    ];
    
    const description = `${descriptionParts[0][Math.floor(Math.random() * descriptionParts[0].length)]} ${
      descriptionParts[1][0]
    } ${descriptionParts[2][Math.floor(Math.random() * descriptionParts[2].length)]} ${
      descriptionParts[3][Math.floor(Math.random() * descriptionParts[3].length)]} ${
      descriptionParts[4][0]
    } ${descriptionParts[5][Math.floor(Math.random() * descriptionParts[5].length)]} ${
      descriptionParts[6][0]
    } ${descriptionParts[7][Math.floor(Math.random() * descriptionParts[7].length)]}.`;
    
    // Generate a source
    const sources = [
      'The MET Collection', 'MOMA Archive', 'Design Museum', 'Dezeen', 
      'Architizer', 'ArchDaily', 'Wallpaper', 'Core77', 'Design Milk', 
      'Cereal Magazine', 'Kinfolk', 'Dwell'
    ];
    
    // For simplicity, using placeholder image paths from your existing assets
    // Get a random image from the assets-discover folder
    const images = [
      'discover-archidit-1.jpeg',
      'discover-archidit-2.jpeg',
      'discover-dessellepartners-1.jpeg',
      'discover-dessellepartners-2.jpeg',
      'discover-dessellepartners-3.jpeg',
      'discover-galeriemcde-1.jpeg',
      'discover-laexplained-1.jpeg',
      'discover-lahistory-1.jpeg',
      'discover-leahoconnell-1.jpeg',
      'discover-morentzgallery-1.jpeg',
      'discover-rumahrubahbali-1.jpeg',
      'discover-rumahrubahbali-2.jpeg',
      'discover-santamonicaproper-1.jpeg',
      'discover-thibautmathieu-1.jpeg',
      'discover-thibautmathieu-2.jpeg',
      'discover-thibautmathieu-3.jpeg',
      'discover-tomkligerman-1.jpeg',
      'discover-tomkligerman-2.jpeg',
      'discover-vintagebathroomlove-1.jpeg'
    ];
    
    const randomImage = images[Math.floor(Math.random() * images.length)];
    
    return {
      id: `discover_${index.toString().padStart(3, '0')}`,
      title: title,
      description: description,
      tags: allTags,
      image: `/assets-discover/${randomImage}`,
      source: sources[Math.floor(Math.random() * sources.length)]
    };
  }
  
  // Generate the full discover.json content
  export function generateDiscoverJson(count = 50) {
    const entries = Array.from({ length: count }, (_, i) => generateDiscoverItem(i + 1));
    
    return {
      entries: entries
    };
  }
  
  // Convert the data to a formatted JSON string
  export function formatJsonOutput(data) {
    return JSON.stringify(data, null, 2);
  }